import React, { memo } from 'react';

import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import Row from '@components/RatingTable/components/ProductPopup/components/Row';
import type ITabDetail from '@components/RatingTable/components/ProductPopup/interfaces/ITabDetail';

import DepositConditionBlock from './DepositConditionBlock';

interface IProps {
  config: ITabDetail;
  additionalInformationClassName?: string;
  product: IProduct;
  rowClassName?: string;
}

const Detail: React.FC<IProps> = memo((props: IProps) => {
  const { config, product, rowClassName, additionalInformationClassName } = props;

  return (
    <>
      {config.rows.map((row, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Row className={rowClassName} product={product} key={index} row={row} />
      ))}
      {config.additionalInformation && product[config.additionalInformation.property] && (
        <div className={additionalInformationClassName}>{product[config.additionalInformation.property]}</div>
      )}
      <DepositConditionBlock product={product} />
    </>
  );
});

export default Detail;
